// packages/components/src/homepage/hero/IntegrationChip.tsx
import React from 'react';
import clsx from 'clsx';

export type ChipAccent =
  | 'emerald' | 'violet' | 'sky' | 'amber' | 'rose' | 'indigo'
  | 'cyan' | 'teal' | 'orange' | 'slate' | 'blue' | 'green';

const styleMap: Record<ChipAccent, { bg: string; text: string; ring: string }> = {
  emerald: { bg: 'from-emerald-50 to-emerald-100', text: 'text-emerald-800', ring: 'ring-emerald-500' },
  violet:  { bg: 'from-violet-50 to-violet-100',   text: 'text-violet-800',  ring: 'ring-violet-500'  },
  sky:     { bg: 'from-sky-50 to-sky-100',         text: 'text-sky-800',     ring: 'ring-sky-500'     },
  amber:   { bg: 'from-amber-50 to-amber-100',     text: 'text-amber-900',   ring: 'ring-amber-500'   },
  rose:    { bg: 'from-rose-50 to-rose-100',       text: 'text-rose-800',    ring: 'ring-rose-500'    },
  indigo:  { bg: 'from-indigo-50 to-indigo-100',   text: 'text-indigo-800',  ring: 'ring-indigo-500'  },
  cyan:    { bg: 'from-cyan-50 to-cyan-100',       text: 'text-cyan-800',    ring: 'ring-cyan-500'    },
  teal:    { bg: 'from-teal-50 to-teal-100',       text: 'text-teal-800',    ring: 'ring-teal-500'    },
  orange:  { bg: 'from-orange-50 to-orange-100',   text: 'text-orange-800',  ring: 'ring-orange-500'  },
  slate:   { bg: 'from-slate-50 to-slate-100',     text: 'text-slate-800',   ring: 'ring-slate-400'   },
  blue:    { bg: 'from-blue-50 to-blue-100',       text: 'text-blue-800',    ring: 'ring-blue-500'    },
  green:   { bg: 'from-green-50 to-green-100',     text: 'text-green-800',   ring: 'ring-green-500'   },
};

export const IntegrationChip: React.FC<{
  label: string;
  accent?: ChipAccent;
  variant?: 'solid' | 'outline' | 'dashed';
  className?: string;
}> = ({ label, accent = 'slate', variant = 'solid', className }) => {
  const s = styleMap[accent] ?? styleMap.slate;
  const bg = variant === 'outline' ? 'bg-white' : `bg-gradient-to-b ${s.bg}`;
  const borderDash = variant === 'dashed' ? 'border-dashed' : 'border-solid';
  return (
    <span
      aria-hidden
      className={clsx(
        'inline-flex items-center h-9 px-3.5 rounded-xl',
        'border-2 border-black',
        borderDash,
        'text-sm font-bold whitespace-nowrap select-none',
        'ring-1', s.ring,
        bg, s.text,
        'pointer-events-none', // not interactable
        'transition-none',     // no hover
        className
      )}
    >
      {label}
    </span>
  );
};

export default IntegrationChip;
